import { render, staticRenderFns } from "./BrokersTable.vue?vue&type=template&id=e6c64e94&"
import script from "./BrokersTable.vue?vue&type=script&lang=js&"
export * from "./BrokersTable.vue?vue&type=script&lang=js&"
import style0 from "./BrokersTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports